export const GetWorkflow = 'GetWorkflow'
export const UpdateStatus = 'UpdateStatus'
export const SetCompleteLabel = 'SetCompleteLabel'